<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyAPI from "@/services/company/companyAPI";
import TrainingAPI from "@/services/standards/trainingProgram/trainingProgramAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import employeeAPI from "../../../services/employee/employeeAPI";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "1.2.1  Programa de capacitación anual",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "1.2.1  Programa de capacitación anual",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "1.2.1 Listado de Programas de Capacitación Promoción y Prevención",
          href: `/forms/estandares/${this.$store.getters["company/getCompany"].id}/promocion-prevencion`,
        },
        {
          text: "Edición de Programa",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,

      loading: true,

      program: {
        start_date: null,
        end_date: null,
        training_done: null,
        observations: null,
        responsibility: null,
        training_name: null,
      },

      submitted: false,

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      promotionID: this.$route.params.promotion,
    };
  },
  validations: {
    program: {
      start_date: {
        required,
      },
      end_date: {
        required,
      },
      training_done: {
        required,
      },
      observations: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 9)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find((permission) => permission.name === name);

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          employeeAPI.getEmployeesPromocion(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });

    },

    getData() {
      TrainingAPI.get(this.promotionID)
        .then((response) => {
          this.program.start_date = response.start_date;
          this.program.end_date = response.end_date;
          this.program.observations = response.observations;
          this.program.training_done = response.training_done;
          this.program.responsibility = response.responsibility;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />

              <div class="form-row col-12">

                <b-form-group class="col-md-6 px-2" label="Nombre de la capacitación" label-for="name">

                  <h4 class="header-title col-8">
                    {{ this.program.training_done }}
                  </h4>
                </b-form-group>
                <b-form-group label-for="employee" class="col-md-6 px-2" label="Responsable de implementación">
                  <select disabled required class="form-control" v-model="program.responsibility">
                    <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                      {{ item.full_name }}
                    </b-form-select-option>
                  </select>
                </b-form-group>
              </div>
              <div class="form-row col-12">
                <b-form-group class="col-md-6 px-2" label="Fecha planificada inicio de capacitación"
                  label-for="trainingDate">
                  <h4 class="header-title col-8">
                    {{ this.program.start_date }}
                  </h4>
                </b-form-group>

                <b-form-group class="col-md-6 px-2" label="Fecha planificada fin de capacitación" label-for="endDate">
                  <h4 class="header-title col-8">
                    {{ this.program.end_date }}
                  </h4>
                </b-form-group>
              </div>

              <div class="form-row col-12">
                <b-form-group class="col-md-12 px-2" label="Observaciones" label-for="description">
                  <h4 class="header-title col-8">
                    {{ this.program.observations }}
                  </h4>
                </b-form-group>
              </div>

            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
